/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CreateReportsResponse,
  postCreateReport: (params: vp.CreateReportRequest) => void,
  postCreateReportAsync: (params: vp.CreateReportRequest) => Promise<vp.CreateReportsResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCreateReport: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCreateGroup, setShouldCreateGroup] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CreateReportRequest>({
    PortalUser: '',
    ReportName: '',
    Description: '',
    PaymentRails: '',
    ScheduleType: '',
    DateFormat: '',
    FromDate: '',
    ToDate: '',
    RecipientEmails: '',
    AccountTransactionReportType: '',
    IncludeSubAccounts: false,
    IncludeGraph: false,
    DateRangeOption: '',
    TransactionReportFailureReasons: '',
  });
  const [response, setResponse] = useState<vp.CreateReportsResponse>({
    Success: false,
    ErrorMessage: '',
    AccountSubscriptionReport: {
      ID: '',
      ReportName: '',
      Description: '',
      ScheduledDate: '',
      IsActive: '',
      PaymentRails: {},
      ScheduleType: '',
      DateFormat: '',
      FromDate: '',
      ToDate: '',
      DateAdded: '',
    },
  });

  useEffect(() => {
    if (!shouldCreateGroup) return () => {};

    const PostCreateReport = async () => {
      setDataFetchingInfo(true, 'creating report', 'fullScreen');
      const res = await api.postCreateReport(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCreateGroup) void PostCreateReport();
    setShouldCreateGroup(false);
    return () => {
      source.cancel();
    };
  }, [shouldCreateGroup]);

  return [
    response,
    (_params: vp.CreateReportRequest) => {
      setParams(_params);
      setShouldCreateGroup(true);
    },
    async (_params: vp.CreateReportRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.postCreateReport(_params, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        AccountSubscriptionReport: {
          ID: '',
          ReportName: '',
          Description: '',
          ScheduledDate: '',
          IsActive: '',
          PaymentRails: {},
          ScheduleType: '',
          DateFormat: '',
          FromDate: '',
          ToDate: '',
          DateAdded: '',
        },
      });
      setShouldCreateGroup(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCreateReport);
